<template>
  <section class="contact-map-section">
    <l-map id="contact-map" class="contact-map-wrap" :center="center" :zoom="18"
      :options="{ attributionControl: false }">
      <l-tile-layer :url="tileUrl" />
      <l-marker :lat-lng="center">
        <l-popup >
          <div v-html="t('contactUs.info.map.address')"></div>
        </l-popup>
      </l-marker>
    </l-map>
  </section>
</template>

<script setup>
import { LMap, LTileLayer, LMarker, LPopup } from 'vue3-leaflet'
import 'leaflet/dist/leaflet.css'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

// 替换为实际经纬度（纬度, 经度）
const center = [23.069696, 114.258665]
const tileUrl = 'https://webrd02.is.autonavi.com/appmaptile?lang=zh_cn&size=1&scale=1&style=8&x={x}&y={y}&z={z}'
</script>

<style scoped>
.contact-map-section {
  width: 70vw;
  height: 60vh;
  background: #fff;
  display: flex;
  justify-content: center;
  margin: 0 auto;
  margin-bottom: 30px;
}

.contact-map-wrap {
  width: 100%;
  height: 500px;
  margin: 40px auto;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

/* 修复 Leaflet 图标缺失 */
@import 'leaflet/dist/leaflet.css';

:deep(.leaflet-container) {
  background: #fff;
}

:deep(.leaflet-marker-icon) {
  background-size: cover;
}

/* 大屏幕设备 (1400px 以上) */
@media screen and (min-width: 1400px) {
  .contact-map-section {
    width: 65vw;
  }
}

/* 笔记本电脑 */
@media screen and (max-width: 1399px) {
  .contact-map-section {
    width: 75vw;
  }
}

/* 平板设备 */
@media screen and (max-width: 991px) {
}

/* 手机设备 */
@media screen and (max-width: 767px) {}
</style>